import PortalFormAccess from 'components/molecules/portal_form_access';
import React, { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { PortalsManagerState, PortalsTypes } from 'store/modules/portals_manager_store/types';

interface PortalModalAccessProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  action: string;
  setAction: React.Dispatch<React.SetStateAction<string>>;
  portal: PortalsTypes | null;
}

const PortalModalAccess = (props: PortalModalAccessProps) => {
  const { showModal, setShowModal, action, portal, setAction } = props;
  const { request } = useSelector<ApplicationState, PortalsManagerState>(
    (state) => state.session.portals_manager,
  );

  useEffect(() => {
    setShowModal(false);
  }, [request?.update_portal?.loaded]);

  return (
    <Modal size="lg" show={showModal}>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title font-weight-bold">
            {action === 'edit'
              ? 'Editar acesso'
              : action === 'view'
              ? 'Visualizar acesso'
              : 'Detalhe do item'}
          </h5>
          <button
            aria-label="Close"
            className="close"
            onClick={() => setShowModal(false)}
            type="button"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <PortalFormAccess source={action} portal={portal} setAction={setAction} />
        </div>
      </div>
    </Modal>
  );
};
export default PortalModalAccess;
